<app-expansion-panel
    [disabled]="!documentService.canAccessDocument()"
    [matTooltip]="'insufficientPermissions' | transloco"
    [matTooltipDisabled]="documentService.canAccessDocument()">
    <div
        class="flex flex-row"
        header>
        <span class="font-medium text-xl items-center">
            {{ (areDocumentsLost() ? 'lostDocument' : 'document') | transloco }}
        </span>
        <span class="pt-1 pl-2">({{ documentList().length }})</span>
    </div>

    <div content>
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else {
            @if (documentList().length) {
                <span class="text-outline font-normal">{{ subTitle() | transloco }}</span>
            }
            @for (document of documentList(); track document) {
                <app-entity-link-document
                    [data]="data()"
                    [dataEntity]="dataEntity()"
                    [document]="document"
                    [showAddButton]="$last && documentService.canManageDocuments() && !areDocumentsLost()" />
            } @empty {
                <div class="flex flex-col justify-center text-center gap-4">
                    <p class="text-on-surface">{{ 'noDocument' | transloco }}</p>
                    <app-button
                        [disabled]="!documentService.canManageDocuments() || areDocumentsLost()"
                        [icon]="['fas', 'plus']"
                        [label]="'add' | transloco"
                        [matTooltip]="
                            (documentService.canManageDocuments() ? '' : 'insufficientPermissions') | transloco
                        "
                        [type]="ButtonType.PRIMARY"
                        (onClick)="documentService.add(dataEntity())" />
                </div>
            }

            @if (documentList().length && areDocumentsLost()) {
                <div class="mt-4">
                    <app-button
                        [disabled]="!documentService.canAccessDocument()"
                        [icon]="['fas', 'download']"
                        [label]="'downloadAll' | transloco"
                        [matTooltip]="
                            (documentService.canAccessDocument() ? '' : 'insufficientPermissions') | transloco
                        "
                        [type]="ButtonType.PRIMARY"
                        (onClick)="documentService.downloadAll(documentList())" />
                </div>
            }
        }
    </div>
</app-expansion-panel>
